import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { hero } from "@/lib/home-content";
import { scrollToId } from "@/lib/scroll";
import HeroWire from "@/components/HeroWire";

export default function Hero() {
    return (
        <section id="top" data-testid="hero-section" className="relative flex flex-1 flex-col overflow-hidden bg-white pt-28 sm:pt-32">
            <HeroWire />
            <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 -translate-y-6 flex-col items-start justify-center px-6 pb-6 text-left sm:px-10 lg:px-14 xl:px-16 2xl:px-8 2xl:-translate-x-10">
                <h1
                    data-testid="hero-headline"
                    className="font-display text-[clamp(1.85rem,calc(7.2vw-5px),6.4375rem)] font-extrabold leading-[1.1] tracking-[-0.035em] text-[#0a0a0b]"
                >
                    <span className="block whitespace-nowrap">We build <span className="text-gradient">AI-powered</span></span>
                    <span className="block whitespace-nowrap text-gradient">SaaS, websites &amp;</span>
                    <span className="block whitespace-nowrap">
                        <span className="text-gradient">automation</span> real
                    </span>
                    <span className="block whitespace-nowrap">businesses run on.</span>
                </h1>

                <p className="mt-6 max-w-3xl text-balance text-sm leading-relaxed text-[#5c574f] sm:mt-7 sm:text-[15px]">{hero.subtitle}</p>

                <div className="mt-5 flex flex-wrap items-center gap-3">
                    <button
                        type="button"
                        data-testid="hero-book-consultation-button"
                        onClick={() => scrollToId("#contact")}
                        className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#0a0a0b] px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
                    >
                        {hero.primaryCta}
                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                    </button>
                    <Link
                        to="/products"
                        data-testid="hero-see-products"
                        className="inline-flex items-center justify-center rounded-full bg-white/80 px-5 py-2.5 text-sm font-semibold text-[#0a0a0b] ring-1 ring-black/10 hover:bg-white"
                    >
                        {hero.secondaryCta}
                    </Link>
                </div>

                <button
                    type="button"
                    data-testid="hero-meter-link"
                    onClick={() => scrollToId("#cost-meter")}
                    className="mt-4 text-sm font-semibold text-[#0a0a0b] underline decoration-black/40 underline-offset-4 hover:text-[var(--brand)]"
                >
                    {hero.meterCta}
                </button>
            </div>
        </section>
    );
}
